// This file was automatically generated from appshared.dialog.reassignPatient.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.reassignPatient');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.reassignPatient.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form><div class="el8TextareaWrap"><input class="w100 el8LgText" name="patientName" /></div><p class="spacer5 el8Wrap el8AppColor additional-info"></p></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.reassignPatient.addlInfoText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.modelClass == 'Report') ? 'NOTE: Only the report data, images, and tags will be moved. Associated notes or addendums will be discarded. Re-filing this report to another patient may result in a reload of this chart if other records are affected.' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.reassignPatient.title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.modelClass == 'Report') ? 'Select new patient to re-file report with...' : 'Select patient to file to');
  if (!opt_sb) return output.toString();
};
